export const defaultBg = {
    "homeId": 0,
    "backgroundImg": "asi-bg-main.jpg",
    "homeTitle": "MAPITALY",
    "homeDescription": "Welcome, please login here",
    "loginBtnImg": "loginBtmImageDefault.jpg",
};


export const defaultHome = {
    "homeId": 0,
    "fetchHome": "bgDefault.jpg",

};
